import { RefObject, useEffect, useState } from 'react';

import Box from '@mui/material/Box';

import useAdminCreditUsageFilters from '@features/admin-credit-usage/hooks/useAdminCreditUsageFilters.tsx';
import MainTable from '@components/MainTable';
import { useTanStackTable } from '@hooks/useTanStackTable';
import { createAdminCreditUsageTotalTableColumns } from '@features/admin-credit-usage/containers/AdminCreditUsageTotalTable/columns.tsx';
import { AdminCreditUsageTotalTableRow } from '@features/admin-credit-usage/types';
import AdminCreditUsageTotalTableToolbar from '@features/admin-credit-usage/containers/AdminCreditUsageTotalTable/toolbar.tsx';

function AdminCreditUsageTotalTable() {
  const { totalTableData } = useAdminCreditUsageFilters();
  const [tableRef, setTableRef] = useState<RefObject<HTMLTableElement> | null>(
    null
  );

  const { table, setColumns, setData } =
    useTanStackTable<AdminCreditUsageTotalTableRow>({
      tableData: [],
      columnConfig: [],
    });

  useEffect(() => {
    if (!totalTableData) return;
    setColumns(createAdminCreditUsageTotalTableColumns(totalTableData));
    setData(totalTableData.rows);
  }, [totalTableData]);

  return (
    <Box display="flex" flexDirection="column" gap={2} marginTop={3}>
      <AdminCreditUsageTotalTableToolbar table={table} tableRef={tableRef} />
      <MainTable table={table} onTableRefReady={(ref) => setTableRef(ref)} />
    </Box>
  );
}

export default AdminCreditUsageTotalTable;
